export const fetchRemoteCalendar = params => dispatch => {
    window.axios.get('/api/remote-calendar').then(response => {
        dispatch({
            type: 'GET_REMOTE_EVENTS',
            payload: response.data,
        });
    });
};

export const fetchVacationCalendar = params => dispatch => {
    window.axios.get('/api/vacation-calendar').then(response => {
        dispatch({
            type: 'GET_VACATION_EVENTS',
            payload: response.data,
        });
    });
};

export const fetchReleaseCalendar = () => dispatch => {
    window.axios.get('/api/release-calendar').then(response => {
        dispatch({
            type: 'GET_RELEASE_EVENTS',
            payload: response.data.events,
        });
    });
};

export const fetchMeetingRoomAvailability = () => dispatch => {
    window.axios.get('/api/meeting-availability-calendar').then(response => {
        dispatch({
            type: 'GET_MEETING_AVAILABILITY',
            payload: response.data,
        });
    });
};



// WEBPACK FOOTER //
// ./src/actions/calendar.js